import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CsIconModule } from '@cbuild/controls';
import { InfoComponent } from './info.component';

@NgModule({
  declarations: [InfoComponent],
  imports: [CommonModule, CsIconModule],
  exports: [InfoComponent]
})
export class InfoModule {}
